import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Router, RouterModule } from '@angular/router';

@Component({
	selector: 'app-enroll-hardcoded-message',
	standalone: true,
	imports: [RouterModule],
	templateUrl: './enroll-hardcoded-message.component.html',
	styleUrl: '../../globalStyle/limit-dialog-box-common.scss'
})
export class EnrollHardcodedMessageComponent {


	constructor(
		private dialogRef: MatDialogRef<EnrollHardcodedMessageComponent>,
		private router: Router
	) { }

	goToUpgradePage() {
		this.router.navigate(['/student-dashboard/upgrade-plan']);
		this.close();
	}

	close() {
		this.dialogRef.close();
	}
}
